import { render } from "./agents.vue?vue&type=template&id=bb7a5556&scoped=true"
import script from "./agents.vue?vue&type=script&lang=js"
export * from "./agents.vue?vue&type=script&lang=js"

import "./agents.vue?vue&type=style&index=0&id=bb7a5556&lang=scss&scoped=true"

import exportComponent from "E:\\zhouwang\\work\\web_dev\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb7a5556"]])

export default __exports__